import { render, staticRenderFns } from "./OrderCalendarCard.vue?vue&type=template&id=2ba3c290&scoped=true&"
import script from "./OrderCalendarCard.vue?vue&type=script&lang=js&"
export * from "./OrderCalendarCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderCalendarCard.vue?vue&type=style&index=0&id=2ba3c290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3c290",
  null
  
)

export default component.exports